import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

import { FullLayoutComponent } from "./layouts/full-layout/full-layout.component";
import { CommonLayoutComponent } from "./layouts/common-layout/common-layout.component";

import { FullLayout_ROUTES } from "./shared/routes/full-layout.routes";
import { CommonLayout_ROUTES } from "./shared/routes/common-layout.routes";
import { LoginComponent } from './authentication/login/login.component';
import { Error1Component } from './authentication/error-1/error-1.component';
import { AuthGuard } from './auth/auth.guard';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component'

const appRoutes: Routes = [
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'unauthorized',
        component: UnauthorizedComponent
    },
    {
        path: 'dashboard',
        redirectTo: '',
        canActivate: [AuthGuard],
        children: CommonLayout_ROUTES 
    },
    { 
        path: '',
        component: CommonLayoutComponent,
        canActivate: [AuthGuard],
        children: CommonLayout_ROUTES 
    },
    { 
        path: '',
        component: FullLayoutComponent,
        canActivate: [AuthGuard],
        children: FullLayout_ROUTES
    },
    {
        path: '**',
        canActivate: [AuthGuard],
        component: Error1Component
    
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, { 
            preloadingStrategy: PreloadAllModules,
            anchorScrolling: 'enabled',
            scrollPositionRestoration: 'enabled' 
        })
    ],
    exports: [
        RouterModule
    ]
})

export class AppRoutingModule {
}